import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Compass } from 'lucide-react';
import { Button } from '@most/ui';

/**
 * The 404. It is a card rather than a bare centred block, so a mistyped URL lands on the same
 * surface language as every other screen — the muted icon tile is the one from DesktopOnlyNotice.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded border border-border bg-card px-6 py-20 text-center shadow-card">
      <div className="flex h-14 w-14 items-center justify-center rounded bg-muted">
        <Compass className="h-6 w-6 text-muted-foreground" aria-hidden="true" />
      </div>
      <div className="space-y-1">
        <h1 className="text-base font-semibold">{t('errors.notFound')}</h1>
        <p className="mx-auto max-w-sm text-sm text-muted-foreground">
          {t('errors.notFoundBody')}
        </p>
      </div>
      <Button asChild size="sm">
        <Link to="/">{t('errors.goHome')}</Link>
      </Button>
    </div>
  );
}
